export default {"src":"/_next/static/media/User.37d10f5f.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};